import 'core-js/features/array/at';

import './core/configure'; // this must be imported before the app to ensure the configuration is done before any app code executes
import { createApp } from './core/app';
import store from '@monolith/legacy/store';
import 'autotrack';
import { bootstrapCookieConsent } from './core/cookie-consent/bootstrap';
import { captureException } from '@core/plugins/sentry';
// @vite import requirements
import '@css/vue-import.scss';
import '@css/app.scss';

(async () => {
  // Consent setup must never block the SPA from mounting. Run it without awaiting
  // so that if setupCookieConsent() rejects (e.g. a chunk fails to load), the app
  // still renders instead of the whole page staying blank.
  bootstrapCookieConsent().catch((error) => {
    captureException(error);
  });
  await createApp(store);
})();
